import axios from "axios";
import { Message, Loading } from "element-ui";

let loading;
let requestCount = 0;
let duration = 2 * 1000;
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

function startLoading() {
    if (requestCount === 0) {
        loading = Loading.service({
            lock: true,
            text: "数据加载中...",
            background: "rgba(0,0,0,.4)"
        });
    }
    requestCount++;
}

function stopLoading() {
    requestCount--;
    if (requestCount <= 0) {
        requestCount = 0;
        if (loading) {
            loading.close();
            loading = null;
        }
    }
}

const service = axios.create({
    baseURL: '/lawcase/api',
    //baseURL:process.env.VUE_APP_INVOICEAPI,
    timeout: 10000,
    headers: { 'content-type': "application/json;charset=UTF-8" }
});


service.interceptors.request.use(
    config => {
        if (!config.stopLoading) {
            startLoading();
        }
        return config;
    },
    error => {
        console.log(error); // for debug
        stopLoading();
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        stopLoading();
        const { status, data } = response;
        if (response instanceof Blob) {
            return response;
        }
        if (status !== 200) {
            Message({
                message: data.message || "Error",
                type: "error",
                duration
            });
            return false;
        } else {
            return data
        }
    },
    error => {
        stopLoading();
        let res = error.response;
        let message = "";
        console.log(error.response);
        // if (res && res.status === 500) {
        //     Message({
        //         message: res.data.message || '服务器异常',
        //         type: "error",
        //         duration
        //     });
        // } else {
        //     Message({
        //         message: res.data.message || '服务器异常',
        //         type: "error",
        //         duration
        //     });
        // }
        return Promise.reject(res);
    }

);

export default service;